<script setup lang="ts">
import PointMarker from './PointMarker.vue'

defineProps({
  style: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <PointMarker subtype="small_dot" :style />
</template>
